import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { defaultLeaderboardColumns } from './constant';

type PerformanceState = {
  status: Record<string, 'loading' | 'error' | 'done'>;
  leaderboards: any;
  performanceCards: any;
  rankings: {
    data: any;
    table: {
      title: string;
      columns: any;
    };
    meta?: {
      lastUpdated: any;
      startDate: any;
      about?: any;
    };
    individual: {
      points: {
        value: number;
        name: string;
      };
      rank: {
        value: number;
        name: string;
      };
    };
    listViewOptions: { code: string; name: string }[];
  };
};

const initialState: PerformanceState = {
  status: {},
  leaderboards: [],
  performanceCards: [],
  rankings: {
    data: [],
    individual: {
      points: {
        value: 0,
        name: 'My Points',
      },
      rank: {
        value: 0,
        name: 'My Ranking',
      },
    },
    table: {
      title: 'Top Scorers',
      columns: defaultLeaderboardColumns,
    },
    listViewOptions: [],
  },
};

export const performanceSlice = createSlice({
  name: 'performanceDashboard',
  initialState,
  reducers: {
    setStatus(
      state: PerformanceState,
      action: PayloadAction<PerformanceState['status']>,
    ) {
      state.status = {
        ...state.status,
        ...action.payload,
      };
    },
    setPerformanceCards(
      state: PerformanceState,
      action: PayloadAction<PerformanceState['performanceCards']>,
    ) {
      state.performanceCards = action.payload;
    },
    setLeaderboards(
      state: PerformanceState,
      action: PayloadAction<PerformanceState['leaderboards']>,
    ) {
      state.leaderboards = action.payload;
    },
    setRankings(
      state: PerformanceState,
      action: PayloadAction<PerformanceState['rankings']>,
    ) {
      state.rankings = action.payload;
    },
  },
});

export const { setStatus, setLeaderboards, setRankings, setPerformanceCards } =
  performanceSlice.actions;

const reducer = { performanceDashboard: performanceSlice.reducer };

export default reducer;
